import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, map, throwError } from 'rxjs';
import { CotizacionEstadoResponse } from '../../models/cotizacion-estado/cotizacion-estado.model';
import { environment } from '../../../environments/environment';
import { URL_MAP } from '../../shared/urlMap';

@Injectable({
  providedIn: 'root'
})
export class CotizacionEstadoService {
     
  private readonly apiUrl = `${environment.HOST}${URL_MAP.API.COTIZADOR_COTIZACION_ESTADO}`;

  constructor(private httpClient: HttpClient) { }

  /**
   * Consulta los estados de cotización disponibles
   * @returns Observable con la respuesta completa de estados
   */
  getEstadosCotizacion(): Observable<CotizacionEstadoResponse> {
    return this.httpClient.get<CotizacionEstadoResponse>(this.apiUrl).pipe(
      map((response: CotizacionEstadoResponse) => response),
      catchError(error => {
        let errorMessage: string;
        if (error.status === 404) {
          errorMessage = 'No se encontró el recurso de estados de cotización.';
        } else if (error.status === 500) {
          errorMessage = 'Error en el servidor al obtener estados de cotización.';
        } else {
          errorMessage = error.error?.message || 'Error al consultar estados de cotización.';
        }
        console.error('Error en getEstadosCotizacion:', error);
        return throwError(() => errorMessage);
      })
    );
  }
}
